import { ArrayUtils } from "./array-utils";
import { CurrencyUtils } from "./currency-utils";
import { RouteUtils } from "./route-utils";

export var CartUtils = {
    getProductsTotalQuantity: function (cartDetail) {
        if (!cartDetail)
            return 0;

        if (ArrayUtils.isNotEmpty(cartDetail.products) === false)
            return 0;

        var sumProductQuantities = cartDetail.products.reduce(function (sum, product) {
            return sum + (product.quantity || 0);
        }, 0);
        return sumProductQuantities;
    },
    getCartDetailsDecorated: function (cartDetail) {
        if (!cartDetail)
            return this.getCartDetailsTemplate();

        var decoratedCartDetail = cartDetail;
        if (cartDetail === true)
            decoratedCartDetail = {};

        decoratedCartDetail.products = this.getCartDetailsProducts(cartDetail);

        this.cartDetailsEnsureDefaults(decoratedCartDetail);

        return decoratedCartDetail;
    },
    getCartDetailsProducts: function (cartDetail) {
        if (!cartDetail)
            return [];

        if (ArrayUtils.isNotEmpty(cartDetail.products))
            return cartDetail.products;

        if (!cartDetail.line_items)
            return [];

        if (ArrayUtils.isNotEmpty(cartDetail.line_items.physical_items) === false)
            return [];

        return cartDetail.line_items.physical_items;
    },
    getCartDetailsTemplate: function () {
        return {
            currency: {
                symbol: '$'
            },
            products: []
        };
    },
    cartDetailsEnsureDefaults: function (cartDetail) {
        if (!cartDetail)
            return this.getCartDetailsTemplate();

        if (!cartDetail.currency)
            cartDetail.currency = {};

        if (!cartDetail.currency.symbol) {
            if (cartDetail.currency.code) {
                cartDetail.currency.symbol = CurrencyUtils.getSymbolFromCode(cartDetail.currency.code);
            } else {
                cartDetail.currency.symbol = '$';
            }
        }

        if (ArrayUtils.isNotEmpty(cartDetail.products)) {
            for (var i = 0; i < cartDetail.products.length; i++) {
                cartDetail.products[i] = this.decorateProduct(cartDetail.products[i]);
            }
        } else {
            cartDetail.products = [];
        }
    },
    decorateProduct: function (product) {
        if (!product)
            return product;

        product.onHand = product.onHand || 0;

        if (!product.url.includes(GlobalApp.generalSettings.productDetailsPageUrl))
            product.url = `${RouteUtils.ensureNoTrailingSlash(GlobalApp.generalSettings.productDetailsPageUrl)}/${RouteUtils.ensureNoLeadingSlash(product.url)}`;

        return product;
    }
}